import { ExternalProjectAssociationType } from 'projects/enums';
import { IExternalProjectAccount } from 'projects/types';

// The back-end owns the active-link rule; a missing flag counts as inactive.
export const isExternalProjectAccountActive = (
  account?: Partial<Pick<IExternalProjectAccount, 'isLinkActive'>> | null
) => true === account?.isLinkActive;

export const getActiveExternalProjectAccounts = (
  accounts?: IExternalProjectAccount[] | null
): IExternalProjectAccount[] => accounts?.filter(isExternalProjectAccountActive) ?? [];

export const hasActiveExternalProjectAccountLink = (
  accounts: IExternalProjectAccount[] | null | undefined,
  accountNumber: string | null | undefined,
  associationType: ExternalProjectAssociationType
): boolean =>
  !!accountNumber &&
  getActiveExternalProjectAccounts(accounts).some(
    (account) =>
      account.associationType === associationType && account.accountNumber === accountNumber
  );
